// Cantrip damage scaling at character levels 5, 11 and 17, as { 5: '2d10', 11: '3d10', 17: '4d10' }.
// 2024 catalog entries (SRD 5.2) carry it in `cantripUpgrade` ("...levels 5 (2d10), 11 (3d10), and 17 (4d10)").
// Older saved records may still hold 2014 description text ("5th level (2d10)"), which is read as a fallback.
// Only damage increases count: die swaps (Shillelagh), extra riders (True Strike) and beams (Eldritch Blast) don't.
const UPGRADE_TIERS = { 5: /\b5\s*\((\d+d\d+)\)/i, 11: /\b11\s*\((\d+d\d+)\)/i, 17: /\b17\s*\((\d+d\d+)\)/i };
const LEGACY_TIERS = { 5: /5th level \(([^)]+)\)/i, 11: /11th level \(([^)]+)\)/i, 17: /17th level \(([^)]+)\)/i };

const readTiers = (text, patterns) => {
  const scaling = {};
  Object.entries(patterns).forEach(([tier, pattern]) => {
    const match = text.match(pattern);
    if (match) scaling[tier] = match[1].replace(/\s+/g, '');
  });
  return scaling;
};

/** Damage dice by character-level tier for a cantrip, or undefined when it doesn't scale its damage. */
export const extractCantripScaling = (spell = {}) => {
  if (Number(spell?.level) !== 0) return undefined;
  const upgrade = typeof spell.cantripUpgrade === 'string' && /damage increases/i.test(spell.cantripUpgrade)
    ? readTiers(spell.cantripUpgrade, UPGRADE_TIERS)
    : {};
  const scaling = Object.keys(upgrade).length ? upgrade : readTiers(String(spell.description || ''), LEGACY_TIERS);
  return Object.keys(scaling).length ? scaling : undefined;
};
